import request from '@/router/axios'

export const getList = (params) => request({
  url: '/api/produce/env-monitor/station/selectPage',
  method: 'post',
  data: params
})

export const getDetail = (id) => request({
  url: '/api/produce/env-monitor/station/selectId',
  method: 'get',
  params: { id }
})

export const add = (data) => request({
  url: '/api/produce/env-monitor/station/insert',
  method: 'post',
  data
})

export const update = (data) => request({
  url: '/api/produce/env-monitor/station/update',
  method: 'post',
  data
})

export const remove = (id) => request({
  url: '/api/produce/env-monitor/station/deleteId',
  method: 'get',
  params: { id }
})
